import {
  useTranslation,
  withTranslation,
  WithTranslation,
} from 'react-i18next';
import { Alert, Button, Typography, VStack } from '@vivaahealth/design-system';

import styles from './review-upload-page.module.css';

import * as api from '../../../api';

interface ReviewUploadPageProps extends WithTranslation {
  upload: api.PatientUpload.PatientUpload;
  uploadErrorMessage: string;
  title: string;
  navigateToUploadPage: () => Promise<void>;
  navigateToNextPage: () => Promise<void>;
}

const ReviewUploadPage = ({
  upload,
  uploadErrorMessage,
  title,
  navigateToUploadPage,
  navigateToNextPage,
}: ReviewUploadPageProps) => {
  const { t } = useTranslation();

  return (
    <VStack>
      <VStack gap={8} marginBottom={24}>
        {uploadErrorMessage && (
          <Alert variant="danger">{uploadErrorMessage}</Alert>
        )}
        <Typography variant="headline-small" bold>
          {title}
        </Typography>
      </VStack>
      <div className={styles.DocumentReview}>
        <img src={upload.gsPath} alt="review" />
      </div>
      <VStack gap={16} marginTop={32}>
        <Button fullWidth onClick={navigateToNextPage}>
          {t('yesContinue')}
        </Button>
        <Button fullWidth variant="outlined" onClick={navigateToUploadPage}>
          {t('noUpdate')}
        </Button>
      </VStack>
    </VStack>
  );
};

export default withTranslation()(ReviewUploadPage);
